import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=d3d1f9a6&"
import script from "./Recipes.vue?vue&type=script&lang=js&"
export * from "./Recipes.vue?vue&type=script&lang=js&"
import style0 from "./Recipes.vue?vue&type=style&index=0&id=d3d1f9a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports